import { isOffline } from "@/lib/network";
import { useSyncExternalStore } from "react";

const subscribe = (onChange: () => void): (() => void) => {
  window.addEventListener("online", onChange);
  window.addEventListener("offline", onChange);
  return () => {
    window.removeEventListener("online", onChange);
    window.removeEventListener("offline", onChange);
  };
};

const getSnapshot = (): boolean => !isOffline();

/**
 * Whether the device has a route out, as the browser reports it. Only `false`
 * is certain (`lib/network.ts`): it says a request is bound to fail, never
 * that one will succeed — a slow or captive network still reads as online.
 */
export function useIsOnline(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, () => true);
}
